/* Global data store */

export const state = () => ({
  env: process.env.mode,
  config: process.env.config
});

export const mutations = {};

export const actions = {};
